module.exports = __webpack_public_path__ + "static/media/f0_2.b4a14478.png";